"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var util_1 = require("@aperza/util");
var ui_1 = require("@aperza/ui");
var LogoutLink = /** @class */ (function (_super) {
    __extends(LogoutLink, _super);
    function LogoutLink() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LogoutLink.prototype.render = function () {
        var appConfig = util_1.AppService.appConfig();
        var encodedPath = '';
        var path = (location.pathname + location.search).replace(/^\/+/, '');
        if (path !== '/') {
            encodedPath = encodeURIComponent(path);
        }
        var domain = appConfig.baseComDomain;
        var protocol = 'https';
        var port = '';
        if (domain.includes('.local.')) {
            protocol = 'http';
            port = ':8000';
        }
        var url = protocol + "://id" + appConfig.baseComDomain + port + "/logout/" + appConfig.serviceType + "?path=" + (document.domain.match(/order/) ? '' : encodedPath);
        return (react_1.default.createElement("div", { className: "logOut" },
            react_1.default.createElement("a", { "data-tracking-action": "usermenu_logout", href: url },
                react_1.default.createElement(ui_1.Message, { messageId: "userMenu.logout" }))));
    };
    return LogoutLink;
}(react_1.default.Component));
exports.default = LogoutLink;
